import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_ORDER_APP_PATHS, ADMIN_ORDER_V2_APP_PATHS } from '../constants/orders-app-paths.constant';
import AdminOrdersListView from '../views/AdminOrdersList.view';
import AdminArchiveOrdersView from '../views/AdminArchiveOrders.view';
import AdminUpdateOrderView from '../views/AdminUpdateOrder.view';
import AdminOrdersDeliveryNotesList from '../views/AdminOrdersDeliveryNotesList.view';
import AdminOrderDetailsView from '../views/AdminOrderDetails.view';

export default function AdminOrdersRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_ORDER_V2_APP_PATHS.ORDER_DETAILS(':orderId')} component={AdminOrderDetailsView} />
      <Route exact path={ADMIN_ORDER_APP_PATHS.ORDER_UPDATE(':orderId')} component={AdminUpdateOrderView} />
      <Route exact path={ADMIN_ORDER_V2_APP_PATHS.ORDERS_OVERVIEW} component={AdminOrdersListView} />

      <Route exact path={ADMIN_ORDER_V2_APP_PATHS.ARCHIVE_ORDER} component={AdminArchiveOrdersView} />
      <Route exact path={ADMIN_ORDER_V2_APP_PATHS.DELIVERY_NOTES_LIST} component={AdminOrdersDeliveryNotesList} />
    </React.Fragment>
  );
}
